





















































import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const newPassword = ref('');
    const confirmNewPassword = ref('');
    const serverError = ref('');
    const loading = ref(false);
    const submitted = ref(false);
    const verifyingCode = ref(true);
    const resettingEmail = ref('');

    const server = sl.get('serverProxy');
    const router = sl.get('router');

    const oobCode = router.currentRoute.query.oobCode as string;

    const title = computed(() =>
      serverError.value
        ? 'Cannot reset password'
        : `Resetting password for ${resettingEmail.value}`
    );

    const handleAuthError = (err: { code: string; message: string }) => {
      const { code } = err;
      if (code === 'auth/expired-action-code') {
        serverError.value = 'The code you have provided is expired.';
      } else if (code === 'auth/invalid-action-code') {
        serverError.value = 'The code you have provided is invalid.';
      } else if (code === 'auth/user-not-found') {
        serverError.value = 'No user was found for the given code.';
      } else {
        serverError.value = 'There was an unknown error.';
      }
    };

    onMounted(async () => {
      try {
        const email = await server.verifyPasswordResetCode(oobCode);
        resettingEmail.value = email;
      } catch (err) {
        handleAuthError(err as any);
      } finally {
        verifyingCode.value = false;
      }
    });

    const formError = computed(() => {
      if (newPassword.value !== confirmNewPassword.value) {
        return 'Passwords do not match';
      }

      if (newPassword.value.length < 8) {
        return 'Passwords must be at least 8 characters long';
      }

      return '';
    });

    const resetPassword = async () => {
      try {
        loading.value = true;

        await server.resetPassword(oobCode, newPassword.value);
      } catch (err) {
        handleAuthError(err as any);
      } finally {
        loading.value = false;
        submitted.value = true;
      }
    };

    return {
      newPassword,
      confirmNewPassword,
      loading,
      resetPassword,
      submitted,
      formError,
      title,
      serverError,
      resettingEmail,
    };
  },
});
